import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useServiceKey } from '../hooks/useServiceKey';
import { Layout } from './Layout';

interface NotFoundRedirectProps {
  isInvalidServiceKey?: boolean;
}

const NotFoundRedirect: React.FC<NotFoundRedirectProps> = ({ isInvalidServiceKey = false }) => {
  const { serviceKey, isValidKey, isLoading, serviceConfig } = useServiceKey();
  const navigate = useNavigate();
  const location = useLocation();
  const [showErrorPage, setShowErrorPage] = useState(false);
  const [countdown, setCountdown] = useState(5);
  
  useEffect(() => {
    // Show error page after component mounts
    setShowErrorPage(true);
  }, []);

  useEffect(() => {
    if (!showErrorPage) return;
    
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          // Use setTimeout to defer navigation to next tick
          setTimeout(() => {
            console.log('[NotFoundRedirect] Redirecting to /');
            navigate('/', { replace: true });
          }, 0);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, showErrorPage]);
  const handleRedirectNow = () => {
    // Always redirect to home page for any invalid route
    navigate('/', { replace: true });
  };
  if (!showErrorPage) {
    return null;
  }
  const requestedUrl = `${location.pathname}${location.search}${location.hash}`;

  return (
    <Layout 
      currentUser={null} 
      onToggleDebug={() => {}} 
      serviceConfig={serviceConfig}
    >
      <div className="min-h-screen flex items-center justify-center bg-background px-4">
        <div className="max-w-md w-full text-center p-8 bg-background-paper rounded-lg shadow-md border border-border">
          <div className="mb-6">
            <div className="text-6xl mb-4">🚫</div>
            <h1 className="text-2xl font-bold text-foreground mb-2">Page Not Found</h1>
            <p className="text-foreground-muted mb-4">
              The page you requested doesn't exist.
            </p>
          </div>

          <div className="mb-6 p-4 bg-secondary rounded-md">
            <p className="text-sm text-secondary-foreground mb-2">
              <strong>Requested URL:</strong>
            </p>
            <code className="text-xs bg-muted px-2 py-1 rounded break-all">
              {requestedUrl}
            </code>
          </div>

          <div className="mb-6">
            <p className="text-sm text-foreground-muted mb-2">
              Redirecting to home page in:
            </p>
            <div className="text-3xl font-bold text-primary mb-4">
              {countdown}
            </div>
            <button
              onClick={handleRedirectNow}
              className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
            >
              Go to Home Page Now
            </button>
          </div>

          <div className="text-xs text-foreground-muted">
            <p>If you believe this is an error, please check the URL or contact support.</p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFoundRedirect;